module.exports = __webpack_public_path__ + "img/product.047f91b6.jpg";